import React, { useState } from 'react';
import { Card, Avatar, Divider, Modal, Button, Space, Row, Col, Typography } from 'antd';
import { ClockCircleOutlined, YoutubeOutlined, TwitterOutlined } from '@ant-design/icons';
import { TwitterShareButton } from "react-share";
import PlayArea from './playArea';
import GraphArea from './graphArea';

const { Meta } = Card;
const { Text } = Typography;

type Props = {
  videoId: string,
  title: string,
  publishedAt: string,
  description: string,
  thumbnail: string,
  scheduledStartTime: string,
  channel: any,
  hasResults: boolean
}

function VideoDisplayCard(props: Props) {
  const [isGraphOpen, setIsGraphOpen] = useState(false);
  const scheduledStartTime = new Date(props.scheduledStartTime);
  return (
    <div className='VideoDisplayCard' style={{ height: "100%"}}>
      <Card
        bodyStyle={{ height: "100%" }}
        style={{ height: "100%"}}
      >
        <Meta
          avatar={<Avatar src={props.channel.channelIcon} alt={props.channel.channelTitle} />}
          title={props.title}
          description={
            props.description + '¥n'
          }
          style={{ height: 100 }}
        />
        <Divider dashed />

        <div>
          <Space>
            <ClockCircleOutlined />
            {scheduledStartTime.toLocaleString()}
          </Space>
        </div>
        <div>
          <Space>
            <YoutubeOutlined />
            <a
              target="_blank"
              rel="noopener noreferrer"
              title={props.channel.channelTitle}
              href={'https://www.youtube.com/channel/' + props.channel.channelId}
            >
              {props.channel.channelTitle}
            </a>
          </Space>
        </div>
        
        <PlayArea
          videoId={props.videoId}
          title={props.title}
          thumbnail={props.thumbnail}
          startAt={0}
          autoplay={false}
        />
        <Row justify="space-around">
          <Col>
            <Button
              type="primary"
              onClick={()=>{setIsGraphOpen(true)}}
              disabled={!props.hasResults}
            >
              { props.hasResults ? '見どころグラフを開く' : '分析が終わってないよ' }
            </Button>
          </Col>
          <Col>
            <TwitterShareButton
              className='ant-btn ant-btn-primary'
              resetButtonStyle={false}
              url={`\nhttps://v.echoreq.com/hololive/ より\nhttps://www.youtube.com/watch?v=${props.videoId}\n`}
              title={`『${props.title}』\n`}
              related={["echoreq"]}
              hashtags={props.channel.hashTags}
            >
                <TwitterOutlined /> #付きで感想をtweetする
            </TwitterShareButton>
          </Col>
        </Row>
        <Modal 
          title={'『' + props.title + '』見どころグラフ'}
          open={isGraphOpen}
          closable={false}
          destroyOnClose={true}
          width={'100%'}
          onCancel={()=>{setIsGraphOpen(false)}}
          footer={[
            <Button key="back" onClick={()=>{setIsGraphOpen(false)}}>
              Close
            </Button>,
          ]}
        >
          <GraphArea
            channel={props.channel}
            title={props.title}
            videoId={props.videoId}
            thumbnail={props.thumbnail}
          />
        </Modal>
      </Card>
    </div>
  );
}

export default VideoDisplayCard
